import PropTypes from 'prop-types';

export const studentPropTypes = PropTypes.shape({
  id: PropTypes.number,
  fullName: PropTypes.string,
});

export const measuresPropTypes = PropTypes.arrayOf(
  PropTypes.shape({
    headDiameter: PropTypes.number,
    height: PropTypes.number,
    id: PropTypes.number,
    measureDate: PropTypes.number,
    student: studentPropTypes,
    waistCircumference: PropTypes.number,
    weight: PropTypes.number,
  })
);

export const anthropometricMeasurementsPropTypes = PropTypes.shape({
  id: PropTypes.number,
  weight: PropTypes.number,
  height: PropTypes.number,
  headDiameter: PropTypes.number,
  measureDate: PropTypes.number,
  waistCircumference: PropTypes.number,
  student: studentPropTypes,
});
